import {
  Button,
  Grid,
  Dialog,
  AppBar,
  DialogActions,
  Toolbar,
  Typography,
  IconButton,
  Tooltip
} from "@material-ui/core";

import React from "react";
import { API_URL } from "../../constants/api";
import { Report_List } from "../../constants/ssrs_api";
import { apiBatchRequest, apiPost, apiRequest } from "../../utils/api_service";
import { getArrayIndex } from "../../utils/lodash";
import DownloadSSRSPopUp from "../common/button-download-popup";
import FilterReport from "../common/FilterReport/FilterReport";
import moment from "moment";
import {
  getDependentSourceData,
  getQueryParam,
  getToolTipText,
  GetUserConfiguration,
  IsSectionVisible,
  ssrsReportDownload
} from "../../utils/helper";
import { SECTIONS } from "../../constants/appConstants";
import { getDiffInMonths } from "../../utils/date";
import { IoMdCloseCircleOutline } from "react-icons/io";
import { ShowToast, toastType } from "../../utils/toast-service";
import Radio from "@material-ui/core/Radio";
import RadioGroup from "@material-ui/core/RadioGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import FormControl from "@material-ui/core/FormControl";
import commonLabels from "../../constants/messageConstants";
import FilterOff from "../../../src/public/img/common/filterOff.svg"


export default class Reporting extends React.Component {
  constructor(props) {
    super(props);
    
    this.state = {
      isDisabled: false,
      reload: props.reload,
      getAllReports: [],
      getFilters: [],
      reportId: props.reportId,
      filterConfig: [],
      initialConfigData: [],
      colFilteredObj: [],
      openDialog: false,
      filterName: props.filterName,
      reportSectionId: props.reportSectionId,
      getAllFilterData: this.getAllFilterData.bind(this),
      fileName: props.fileName,
      reportName: props.reportName,
      clearFilterData: false,
      allCleared: false,
      reportAvailable: false,
      reportSectionName: props.reportSectionName,
      openSSRSPopup: true,
      reportFormat: "Excel",
      selectedReport: null,
      dateTypeSelected: "MTD",
      selectedQtr: "Q1",
      isPopupOpen: true,
      months: 0,
      enableDownload: false,
      showReport: false,
      isDetailedReport: false,
      isTooltipShow: false,
      toolTipData: [],
      isInErrorState:props.isInErrorState,
      errorMessage:props.errorMessage
    };
  }
  static getDerivedStateFromProps(newProps, state) {
    if (
      newProps.reportSectionId !== state.reportSectionId ||
      newProps.filterName !== state.filterName ||
      newProps.fileName !== state.fileName ||
      newProps.reportName !== state.reportName  
    ) {
      return {
        filterName: newProps.filterName,
        fileName: newProps.fileName,
        reportName: newProps.reportName,
        reportSectionId: newProps.reportSectionId,
        reportAvailable: false,
        reportSectionName: newProps.reportSectionName,
        update: state.getAllFilterData(newProps.reportSectionId)
      };
    }
    else if(newProps.errorMessage !== state.errorMessage){
      
      return {...state, isInErrorState:newProps.isInErrorState,errorMessage:newProps.errorMessage}
    }
    return null;
  }
  componentDidMount() {
    const { reportSectionId } = this.state;
    this.getAllFilterData(reportSectionId);
  }

  /**
 * call on every control on change event
 * @param {*} event -> event of control
 * @param {*} value -> selected value
 * @param {*} key -> key name of control
 * @returns 
 */
  onChange = (event, value) => {
    this.getAllFilterData(value);
    const {getAllReports}= this.state;
    const filterName = getAllReports.find(x => x.ReportId == value)
      .ReportName;
    this.setState({
      reportId: value,
      filterName: filterName
    });
  };

  /**
  * Get the all report list
  * @returns 
  */
  getAllReportData = () => {
    apiRequest({
      url: API_URL.reporting.getAllReports
    }).then(({ data: List }) => {
      this.setState({
        getAllReports: List
      });
    });
  };

  /**
   * filter the dropdown option according to key name
   * @param {*} optionsList -> list of options
   * @param {*} FilterKeyName -> key name
   * @param {*} value -> value of control
   */
  getDependentSource = (optionsList, FilterKeyName, value) => {
    // eslint-disable-next-line react/no-access-state-in-setstate
    const data = getDependentSourceData(optionsList, FilterKeyName, value, this.state, this.state.colFilteredObj);
    const{allCleared}=this.state;
    this.setState(
      {
        filterConfig: data.configData,
        colFilteredObj: data.colFilteredObj,
        allCleared: !allCleared
      });
  };

  /**
   * clear the filter when click on clear filter button
   * @param {*} key 
   */
  onError = (value,message) => {
    // let colFiltered = this.state.colFilteredObj?.filter(e => {
    //   if (e.keyName !== key) return e;
    // });
    this.props.onError(value,message);
  };
  /**
   * Get the filter list according to section id
   * @param {*} sectionId 
   */
  getAllFilterData = sectionId => {
   
    apiBatchRequest([
      {
        url: API_URL.reporting.getFilters,
        params: { sectionId: sectionId },
        key: "getFilters"
      }
    ]).then(({ getFilters }) => {
      const { reportId } = this.props;
      const getAllFilteredDataByReportId = getFilters.data.filter(m => {
        if (m.ReportId === reportId) return m;
      }).filter(x=> x.LableValue !== null);
      const getFilteredDataByReportId = getFilters.rawData.filter(m => {
        if (m.ReportId === reportId) return m;
      }).filter(x=> x.LableValue !== null);

      const rptSectionId = getFilters?.data?.find(x=> x.ReportId === reportId)?.SectionId;
      this.setState({
        reportAvailable: true,
        getFilters: getAllFilteredDataByReportId,
        getList: getFilteredDataByReportId,
        isDisabled: true,
        queryParam: null,
        filterConfig: [],
        colFilteredObj: [],
        isDetailedReport:
          getFilters?.condition?.length > 0 &&
          getFilters?.condition[0].ViewReport === 1,

        isTooltipShow: 
        getFilters?.ignoreColumns?.length > 0 &&
        getFilters?.ignoreColumns[0].ShowTooltip === 1,

      }, () => {        
        const { colFilteredObj } = this.state;
        getAllFilteredDataByReportId?.forEach(m => {
          m.optionsList = getFilteredDataByReportId
            .filter(x => x.FilterId === m.FilterId)
            .map(y => {
              m.ShowLastValueInList = y.ShowLastValueInList;
              return {
                dependentFilter: m.DependentFilter,
                KeyName: m.FilterKeyName,
                value: y.LableValue,
                id: y.LableValue,
                idValue: y.LabelKey,
                filterSourceOn: y.FilterSourceOn
              };
            });
          m.selectedIds = colFilteredObj[m.FilterKeyName];
        });
        this.setState({
          filterConfig: JSON.parse(
            JSON.stringify([...getAllFilteredDataByReportId])
          ),
          initialConfigData: JSON.parse(
            JSON.stringify([...getAllFilteredDataByReportId])
          )
        }, () => {
          this.getToolTip(rptSectionId);
        });
      });
    });
  };

  /**
   * get the toolTip according to selected Report section Id
   * @param {*} sectionId 
   */
  getToolTip = (sectionId) => {
    apiBatchRequest([
      {
        url: API_URL.masterData.GetLabels,
        params: { sectionId: sectionId },
        key: "toolTipData"
      }
    ]).then(({ toolTipData }) => {
  
      this.setState({
        toolTipData: toolTipData.data || []
      });
    });
  }

  /**
   * update the selected filter list
   * @param {*} key -> key name
   * @param {*} value -> value of selected filter list
   * @param {*} filterType -> data type
   * @param {*} id 
   * @param {*} typeOfDate -> type of date 
   * @param {*} QtrSelected -> selected quater
   */
  updateColumnFilter = (
    key,
    value = "",
    filterType,
    id,
    typeOfDate,
    QtrSelected,
    optionsList
  ) => {
    let { colFilteredObj } = this.state;
    const index = getArrayIndex(colFilteredObj, { keyName: key });
    if (index !== -1) {
      colFilteredObj[index] = {
        keyName: key,
        value,
        filterType: filterType || "string",
        idValue: id,
        qtrSelected:QtrSelected
      };
    }
    else {
      colFilteredObj = [
        ...colFilteredObj,
        {
          keyName: key,
          value,
          filterType: filterType || "string",
          idValue: id,
          qtrSelected:QtrSelected

        }
      ]
    }
const{dateTypeSelected}=this.state;
const state = this.state;
const QtrSelectedState= state.QtrSelected;
    if (key) {
      this.setState(
        {
          colFilteredObj: colFilteredObj,
          sortByColKey: value ? key : "",
          dateTypeSelected: typeOfDate
            ? typeOfDate
            : dateTypeSelected,
          selectedQtr: QtrSelected
            ? "Q" + QtrSelected
            : QtrSelectedState
        },
        () => {
          this.forceUpdate();
          if (optionsList && optionsList[0].dependentFilter != null) {
            this.getDependentSource(optionsList, key, value);
          }
        }
      );
    }
  };

  /**
   * clear the filter list
   */
  clearFilter = () => {
    const state = this.state;
    const colFilteredObj= state?.colFilteredObj||[]
    const dateRangeFilter= colFilteredObj.filter(x=>x.filterType==="DateRangeSlider" || x.filterType === "DateRange" ) ||[];
    const weeklySlider = 
      colFilteredObj.filter(
        x => x.filterType === "DateRangeWeeklySlider") || [];
    const clearFilters=[];
    let dateTypeSelected = "MTD"
    if(dateRangeFilter.length>0){
      const start = moment().startOf("month").format("MM/DD/YYYY");
      const end = moment().endOf("month").format("MM/DD/YYYY");
      dateRangeFilter[0].value=start + "-" + end;
      clearFilters.push(dateRangeFilter[0]);
      dateTypeSelected = "MTD";
    } else if (weeklySlider.length > 0) {
      const start = moment()
        .format("MM/DD/YYYY");
      const end = moment()
        .format("MM/DD/YYYY");
      weeklySlider[0].value = start + "-" + end;
      clearFilters.push(weeklySlider[0]);
      dateTypeSelected = "TD";
    } else {
      dateTypeSelected = "NONE";
    }
    localStorage.setItem("DateRadioSelect", dateTypeSelected)
    const {reload, clearFilterData, initialConfigData}= this.state
    this.setState(
      {
        reload:!reload,
        clearFilterData: !clearFilterData,
        colFilteredObj: clearFilters,
        dateTypeSelected: dateTypeSelected,
        filterConfig: JSON.parse(
          JSON.stringify([...initialConfigData])
        )
      }
    );
  };

  /**
   * view the details report when click on View button
   * @param {*} isShow 
   */
  viewReport = isShow => {
    const {
      filterConfig,
      colFilteredObj,
      dateTypeSelected,
      initialConfigData,
      isTooltipShow,
      toolTipData,
      isInErrorState
    } = this.state;

    const props = this.props;
    let dateIncluded = false;
    filterConfig.forEach(n => {
      if (
        ((n["FilterDataType"] == "DateRange" ||
         n["FilterDataType"] == "NullableDateRange" ||
         n["FilterDataType"] == "DateRangeSlider" ||
         n["FilterDataType"] == "DateRangeWeeklySlider" ) &&
        dateIncluded == false)
      ) {
        const dates = colFilteredObj?.find(x => x.keyName == n["FilterKeyName"])?.value?.split("-");
        console.log("dates",dates);

        if(n["ReportId"]==7 || n["ReportId"]==1 || n["ReportId"]==2){
        console.log("dates",dates);
       const months = dates && getDiffInMonths(dates[0], dates[1]) + 1;
       if(months>3){
        this.openDailogToSendReport(
          colFilteredObj?.find(x => x.keyName == n["FilterKeyName"])?.value
        );
        dateIncluded = true;
       }
       }
      }
    });

    if(!dateIncluded && !isInErrorState){
    props.loadUi(
      isShow,
      filterConfig,
      colFilteredObj,
      dateTypeSelected,
      initialConfigData,
      isTooltipShow,
      toolTipData
    );
    }else{
      if(isInErrorState)
      {
        ShowToast(this.state.errorMessage, toastType.ERROR, 2000,500);
      }
    }
  };

  /**
   * call when click on generate report button
   */
  runReport = () => {
    const { enableDownload, colFilteredObj, filterConfig, dateTypeSelected, initialConfigData,isInErrorState,errorMessage} = this.state;

    if(isInErrorState){
      ShowToast(errorMessage,toastType.ERROR, 2000,500);
    }else{
    this.setState({
      isPopupOpen: true,
      enableDownload: !enableDownload
    });
    let dateIncluded = false;
    const props = this.props;
    filterConfig.forEach(n => {
      if (
        (n["FilterDataType"] == "DateRange" &&
        n["ReportId"] == 1 &&
        dateIncluded == false) ||
        (n["FilterDataType"] == "DateRangeWeeklySlider" &&
        n["ReportId"] == 7 &&
        dateIncluded == false) ||
        (n["FilterDataType"] == "DateRangeSlider" &&
        n["ReportId"] == 2 &&
        dateIncluded == false)
      ) {
        dateIncluded = true;
        this.openDailogToSendReport(
          colFilteredObj?.find(x => x.keyName == n["FilterKeyName"])?.value
        );
      }
    });
    this.setState({
      queryParam: getQueryParam(
        colFilteredObj,
        filterConfig,
        dateTypeSelected,
        props.reportId,
        initialConfigData
      )
    });}
  };

  /**
   * call in case of Work order report and detail message
   * @param {*} value 
   */
  openDailogToSendReport = value => {
    const dates = value?.split("-");
    const months = dates && getDiffInMonths(dates[0], dates[1]) + 1;
    const {enableDownload}= this.state
    const props = this.props;
    if (months > 12) {
      this.setState({
        isPopupOpen: false,
        enableDownload: !enableDownload,
        months: months
      });
      ShowToast(
        commonLabels.reportingDateExceed.message,
        toastType.ERROR,
        5000,
        200
      );
    } else if (months > 3) {
      const { colFilteredObj, filterConfig, dateTypeSelected, initialConfigData } = this.state;

      const { eventInitiatedFrom } = this.props;
      let queryParam = getQueryParam(
        colFilteredObj,
        filterConfig,
        dateTypeSelected,
        props.reportId,
        initialConfigData
      );
      queryParam = queryParam + `&EventInitiatedFrom=${eventInitiatedFrom}&ClickEvent=Download`;
      this.setState({
        openDialog: true,
        openSSRSPopup: false,
        TimePeriod: value,
        queryParam
      });
    }
  };

  /**
   * download the report according to selection
   * @param {*} value 
   */
  handleDownloadReport = value => {
    const props = this.props;
    if (value == false) {
      this.setState({
        openDialog: false,
        openSSRSPopup: true,
        reportFormat: "Excel"
      });
    } else {
      const { queryParam, fileName, reportName, reportFormat, dateTypeSelected, TimePeriod } = this.state;

      let reportUrl = null;
      switch (reportFormat) {
        case "MHTML":
          reportUrl = `${Report_List.replace(
            "Replaceable",
            reportName
          )}MHTML${queryParam.replace("&AccessGroupId=1", "")}`;
          break;
        case "WORD":
          reportUrl = `${Report_List.replace(
            "Replaceable",
            reportName
          )}WORD${queryParam.replace("&AccessGroupId=1", "")}`;
          break;
        case "PDF":
          reportUrl = `${Report_List.replace(
            "Replaceable",
            reportName
          )}PDF${queryParam.replace("&AccessGroupId=1", "")}`;
          break;
        case "Excel":
          reportUrl = `${Report_List.replace(
            "Replaceable",
            reportName
          )}EXCELOPENXML${queryParam.replace("&AccessGroupId=1", "")}`;
      }

      const userData = GetUserConfiguration();
      const accessGroupId = userData?.groups[0]?.accessGroupId || 0;

      const params = {
        url: `${reportUrl}&CloudOrgId=2&EmailID=${userData.email}&AccessGroupId=${accessGroupId}`,
        reportName: props.filterName,
        outFormat: reportFormat === "Excel" ? "xlsx" : reportFormat,
        downLoadFileName: fileName,
        selectedDateType:
          dateTypeSelected == "MTD" ||
            dateTypeSelected == "Month"
            ? "Monthly - " + moment(TimePeriod).format("MMM/YYYY")
            : dateTypeSelected == "YTD"
              ? "YTD - " + TimePeriod.replace("-", " thru ")
              : dateTypeSelected == "YEAR"
                ? "Yearly - " + TimePeriod.replace("-", " thru ")
                : dateTypeSelected == "QTR"
                  ? "Quarter - " + TimePeriod.replace("-", " thru ")
                  : dateTypeSelected == "CDR"
                    ? "Date Range - " + TimePeriod.replace("-", " thru ")
                    : ""
      };
      apiPost({
        url: API_URL.reporting.generateReport,
        postBody: params
      }).then(({  success: success }) => {
        if (success) {
          ShowToast(
            "Request to generate report added Successfully",
            toastType.SUCCESS,
            5000,
            200
          );
        } else {
          ShowToast(
            "Something went wrong, please try again.",
            toastType.ERROR,
            5000,
            200
          );
          return;
        }
      });
      this.setState({
        openDialog: false,
        openSSRSPopup: true,
        reportFormat: "Excel"
      });
    }
  };

  /**
   * download the report according to selection
   * @param {*} report  -> report url
   * @param {*} type -> type of report download
   */
  downloadSSRSReport = (report, type = "excel") => {
    const { queryParam, fileName, reportName } = this.state;
    ssrsReportDownload(report, type, queryParam, fileName, reportName);
  };

  /**
   * render report button according to selection of report 
   * @returns 
   */
  renderDownload = () => {
    const { isDetailedReport, openSSRSPopup, toolTipData, isTooltipShow, isPopupOpen, enableDownload, filterName,isInErrorState,errorMessage } = this.state;
    const props = this.props;
    return (
      <>
        {IsSectionVisible(
          SECTIONS.REPORTING,
          SECTIONS.REPORTING,
          SECTIONS.ADD_EDIT
        ) &&
          openSSRSPopup &&
          isDetailedReport && (
            <div className={"col-xs-12 col-md-12 col-lg-12 end-lg"}>
              <Tooltip title={
                  isTooltipShow ?  toolTipData?.find(
                    b => b.UiColumnName == "Clear Filter"
                  )?.Tooltip : "Clear Filter"
                 } 
                 placement={"bottom"} 
                className={"report-clear-filter"} 
                key={"filterOffTooltip"}
              >
                <img
                  className={"icons white-label"}
                  src={FilterOff}
                  style={{ marginBottom: "-12px" }}
                  alt={"logo"}
                  onClick={() => {
                    this.clearFilter();
                  }}
                />
              </Tooltip>
              <Button
                key={"viewReportButton"}
                className={"runReport-btn"}
                variant={"contained"}
                style={{ marginLeft: "10px" }}
                onClick={() => {
                  this.viewReport(true);
                }}
              >
                {" "}
                {"View Report\r"}
              </Button>
            </div>
          )}

        {IsSectionVisible(
          SECTIONS.REPORTING,
          SECTIONS.REPORTING,
          SECTIONS.ADD_EDIT
        ) &&
          openSSRSPopup &&
          !isDetailedReport && (
           <DownloadSSRSPopUp
              isPopupOpen={isPopupOpen && !isInErrorState}
              enableDownload={enableDownload}
              additionalExt={props.reportId == 1 ? true : false}
              isOpen
              runReport={this.runReport}
              buttonLabel={"Print"}
              dataTip={"Download " + filterName}
              reportList={[
                {
                  label: filterName,
                  id: 1,
                  pdfDownload: true,
                  excelDownload: true,
                  // wordDownload: true,
                  // mhtmlDownload: true,
                  downloadLink: Report_List
                }
              ]}
              clearFilter={this.clearFilter}
              downloadBtnLabel={"Download"}
              downloadReport={this.downloadSSRSReport}
              isInErrorState={isInErrorState}
              errorMessage={errorMessage}
           />
          )}
      </>
    );
  };

  /**
   * render the tooltip according to defined key
   * @returns 
   */
  renderToolTip = () => {
    const { toolTipData, TimePeriod } = this.state
    const props = this.props;
    const resultArray = [];
    const toolTip = getToolTipText(toolTipData, "Generate Report");
    const toolTipParts = toolTip.split("@EmailId");
    resultArray.push(toolTipParts[0]);
    resultArray.push(<b>{props.userData}</b>);
    const toolTipParts1 = toolTipParts[1].split("@Date");
    resultArray.push(toolTipParts1[0]);
    resultArray.push(<b>{TimePeriod}</b>);
    resultArray.push(toolTipParts1[1]);
    return resultArray;
  }
  
  render() {
    const state = this.state;
    return (
      <>
        <div className={"report-div"}>
          {state.filterConfig.length > 1 ||
            (state.filterConfig.length > 0 &&
              state.filterConfig[0].optionsList.length > 0) ? (
            <>
              <FilterReport
                allCleared={state.allCleared}
                getDependentSource={this.getDependentSource}
                filterConfig={state.filterConfig}
                clearFilterData={state.clearFilterData}
                reload={state.reload}
                isShowFilter={state.isDisabled}
                onChangeFilter={this.updateColumnFilter}
                runReport={this.runReport}
                renderDownload={this.renderDownload}
                colFilteredObj={state.colFilteredObj}
                reportSectionId={state.reportSectionId}
                onError={this.onError}
              />
            </>
          ) : state.reportAvailable &&
            state.filterConfig.length == 0 ? (
            <Grid container spacing={4}>
              <Grid
                style={{ paddingBottom: "15px" }}
                container
                direction={"row-reverse"}
                justifyContent={"center"}
                alignItems={"stretch"}
              >
                <label className={"item-big"}>
                  {"No Report Available for "}{state.reportSectionName}
                </label>
              </Grid>
            </Grid>
          ) : (
            <Grid container spacing={4}>
              <Grid
                style={{ paddingBottom: "15px" }}
                container
                direction={"row-reverse"}
                justifyContent={"center"}
                alignItems={"stretch"}
              >
                <label className={"item-big"}>{"Loading Reporting data..."}</label>
              </Grid>
            </Grid>
          )}

          {state.openDialog && (
            <Dialog
              style={{ marginTop: "60px" }}
              open={state.openDialog}
              aria-labelledby={"responsive-dialog-title"}
              maxWidth={"md"}
            >
              <AppBar
                style={{ position: "relative", backgroundColor: "#064473" }}
              >
                <Toolbar>
                  <Typography
                    variant={"h6"}
                    style={{ marginLeft: "10px", flex: "1" }}
                  >
                    {"Generate Report\r"}
                  </Typography>
                  <IconButton
                    title={"Close"}
                    edge={"end"}
                    color={"inherit"}
                    onClick={() => this.handleDownloadReport(false, "")}
                    aria-label={"close"}
                    className={"white-button"}
                  >
                    <IoMdCloseCircleOutline />
                  </IconButton>
                </Toolbar>
              </AppBar>
              <div style={{ padding: "6px 13px", fontSize: "larger", lineHeight: "1.5rem" }}>
                {
                  this.renderToolTip().map((el) => {
                    return <>{el}</>
                  })
                }
              </div>

              <FormControl component={"fieldset"} className={"radio-btn-grp"}>
                <RadioGroup
                  aria-label={"Report Type"}
                  name={"reportFormat"}
                  className={"radioGroup"}
                  style={{
                    display: "inline-block",
                    marginLeft: "30px"
                  }}
                  value={state.reportFormat}
                  onChange={event =>
                    this.setState({ reportFormat: event.target.value })}
                >
                  <FormControlLabel
                    value={"Excel"}
                    control={<Radio className={"radio-btn"} color={"primary"} />}
                    label={"Excel"}
                  />
                  <FormControlLabel
                    value={"PDF"}
                    control={<Radio className={"radio-btn"} color={"primary"} />}
                    label={"PDF"}
                  />
                </RadioGroup>
              </FormControl>
              <DialogActions>
                <Button
                  className={"runReport-btn"}
                  variant={"contained"}
                  onClick={() => this.handleDownloadReport(false, "")}
                >
                  {"Close\r"}
                </Button>
                <Button
                  className={"runReport-btn"}
                  variant={"contained"}
                  onClick={() => this.handleDownloadReport(true, "")}
                >
                  {"Generate Report\r"}
                </Button>
              </DialogActions>
            </Dialog>
          )}
        </div>
      </>
    );
  }
}
